import { RentalAgreement } from '@typings/api/contract.types'

const getHash = async (str: string | undefined) => {
  // Client does not support SubtleCrypto, abort
  if (window.crypto?.subtle == null || str == null) return null

  const hashBuffer = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(str))
  const bytes = [...new Uint8Array(hashBuffer)]

  return bytes.map((b) => b.toString(16).padStart(2, '0')).join('')
}

export const validateLocalStorage = async (agreement: RentalAgreement | null) => {
  const newHash = await getHash(agreement?.raNumber)
  // If hash is either the same or uncomputable, abort
  if (localStorage.getItem('raHash') === newHash) return

  localStorage.clear()
  sessionStorage.clear()
  if (newHash != null) localStorage.setItem('raHash', newHash)
}
